module.exports = __webpack_public_path__ + "img/3.02.thmb.xs.e34462ee.jpg";